import React from 'react';
import { acceptB2bInvite, getB2bInvite } from '@api/b2bPortal';
import AcceptInvitePage from '@components/containers/invite/AcceptInvitePage';

/** A B2B customer's way in, from the emailed link: set a password and land in the portal. */
const AcceptCustomerInvite: React.FC = () => (
    <AcceptInvitePage
        description="You've been invited to order online on Reparo: see your prices and schemes, place orders and track dispatches."
        fetchInvite={getB2bInvite}
        accept={acceptB2bInvite}
        landing="/portal/home"
    />
);

export default AcceptCustomerInvite;
